import { forEach, uniq, map } from 'lodash'

export const getAvailablePages = (availablePages, pagesToMatch) => {
  const tabs = []

  forEach(pagesToMatch, item => {
    const { type, isActive } = item
    const page = availablePages[type]

    if (page && isActive) {
      tabs.push({
        ...item,
        ...page
      })
    }
  })

  return tabs
}

export const getFullPath = ({ path, defaultPath, optionalPath }) => (
  path
    ? `${path}${optionalPath || ''}`
    : `${defaultPath}${optionalPath || ''}`
)

// merges paths for the same components to avoid having rerenders while changing routes
export const mergeRoutes = (routes) => {
  const groupedRoutes = []

  // create list of unique components
  const components = uniq(map(routes, ({ component }) => component))

  forEach(routes, route => {
    const index = components.indexOf(route.component)
    const existingComponentRoutes = groupedRoutes[index]
    const fullPath = getFullPath(route)

    if (existingComponentRoutes) {
      existingComponentRoutes.path.push(fullPath)
    } else {
      groupedRoutes[index] = {
        component: route.component,
        path: [fullPath]
      }
    }
  })

  return groupedRoutes
}
